export default {
      id: "ic-birthday-usage",
      viewBox: "0 0 448 512",
      url: "/" + "images/icons.3.109.2.svg#ic-birthday-usage",
      toString: function () {
        return this.url;
      }
    }